import { c as _c } from "react/compiler-runtime";
import { ButtonProps } from '@systemeio/ui';
import { ActivateCampaignStepWithoutButton, ActivateCampaignStepWithoutButtonProps } from 'modules/campaigns/campaign-steps/components/activate-campaign-step/activate-campaign-step-without-button';
import React, { useEffect, useState } from 'react';
interface ActivateCampaignStepModalProps extends Pick<ActivateCampaignStepWithoutButtonProps, 'campaignStepId' | 'campaignId' | 'onConfirm' | 'senderEmail' | 'onSenderEmailChange' | 'initialData' | 'onChange'> {
  disabled?: ButtonProps['disabled'];
  onOpen?: () => Promise<void>;
  opened: boolean;
  onClose: () => void;
}
export const ActivateCampaignStepModal = t0 => {
  const $ = _c(16);
  let onClose;
  let onOpen;
  let opened;
  let props;
  if ($[0] !== t0) {
    const {
      disabled,
      onOpen: t1,
      opened: t2,
      onClose: t3,
      ...t4
    } = t0;
    onOpen = t1;
    opened = t2;
    onClose = t3;
    props = t4;
    $[0] = t0;
    $[1] = onClose;
    $[2] = onOpen;
    $[3] = opened;
    $[4] = props;
  } else {
    onClose = $[1];
    onOpen = $[2];
    opened = $[3];
    props = $[4];
  }
  const [showModal, setShowModal] = useState(false);
  let t1;
  if ($[5] !== onOpen || $[6] !== opened) {
    t1 = () => {
      const onOpenHandle = async () => {
        await onOpen?.();
        setShowModal(true);
      };
      if (opened) {
        onOpenHandle();
      }
    };
    $[5] = onOpen;
    $[6] = opened;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== opened) {
    t2 = [opened];
    $[8] = opened;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  useEffect(t1, t2);
  let t3;
  if ($[10] !== onClose) {
    t3 = () => {
      setShowModal(false);
      onClose();
    };
    $[10] = onClose;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const onCloseHandle = t3;
  const t4 = opened && showModal;
  let t5;
  if ($[12] !== onCloseHandle || $[13] !== props || $[14] !== t4) {
    t5 = <ActivateCampaignStepWithoutButton withModal={true} withConfirmButton={true} isOpened={t4} onClose={onCloseHandle} {...props} />;
    $[12] = onCloseHandle;
    $[13] = props;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};